import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

/**
 * Usage:
        <Tabs 
            activeTabKey={dataSource.type}
            onTabClick={(tabKey) => {
                this.handleDataSourceTabClick(i, tabKey);
        }}>
            <Tab tabKey="SELECT" renderContent={(props) => {
                return <p>Select</p>
            }}>Select a Network</Tab>
            <Tab tabKey="UPLOAD" renderContent={(props) => {
                return <p>Upload</p>
            }}>Upload</Tab>
            <Tab tabKey="MANUAL" renderContent={(props) => {
                return <p>Manual</p>
            }}>Manual</Tab>
        </Tabs>
 */
export class Tabs extends React.Component {

    static propTypes = {
        // Current active tab
        activeTabKey: PropTypes.string,

        // Called when a tab is clicked
        onTabClick: PropTypes.func
    }

    render() {

        // Find which renderContent prop to call based on the active tab
        let activeTabContent = null;

        React.Children.forEach(this.props.children, (child) => {
            if (child && child.props.tabKey === this.props.activeTabKey) {
                activeTabContent = child.props.renderContent(child.props);
            }
        });

        // Pass some of our own props to children, so each child doesn't have to 
        // define these props.
        let children = React.Children.map(this.props.children, (child, index) => {
            if (child) {
                return React.cloneElement(child, {
                    tabKey: child.props.tabKey,
                    isActive: child.props.tabKey === this.props.activeTabKey,
                    onClick: () => {
                        this.props.onTabClick(child.props.tabKey)
                    }
                });
            }
        });

        return (
            <div className="pers-tabs">
                <div className={cx("pers-tabs__tab-nav", this.props.className)}>
                    {children}
                </div>
                <div className="pers-tabs__tab-content">
                    {activeTabContent}
                </div>
            </div>
        );
    }
}

export class Tab extends React.Component {
    
    render() {
        let styles = cx('pers-tabs__tab', {
            'pers-tabs__tab--active': this.props.isActive
        });

        return (
            <div className={styles} onClick={this.props.onClick}>
                {this.props.children}
            </div>
        );
    }
}